import { ColumnSortType, TableColumnTypes } from '../../../../model/table.model';

export const tableHeaders = [
  {
    value: 'primary',
    sort: ColumnSortType.NONE,
    name: '',
    type: TableColumnTypes.CHECKBOX,
    className: 'table-checkbox'
  },
  {
    value: 'id',
    sort: ColumnSortType.NONE,
    name: 'ID',
    type: TableColumnTypes.TEXT,
    className: 'table-header',
    disabled: true,
  },
  {
    value: 'images',
    sort: ColumnSortType.NONE,
    name: '',
    type: TableColumnTypes.OLX_IMAGE,
    className: 'table-header',
    disabled: true,
  },
  {
    value: 'title',
    sort: ColumnSortType.NONE,
    name: 'name',
    type: TableColumnTypes.TITLE,
    className: 'table-header',
    disabled: true,
    translate: true,
  },
  {
    value: 'description',
    sort: ColumnSortType.NONE,
    name: 'description',
    type: TableColumnTypes.TEXT,
    className: 'table-header',
    disabled: true,
    translate: true,
  },
  {
    value: 'price_value',
    sort: ColumnSortType.NONE,
    name: 'price',
    type: TableColumnTypes.TEXT,
    className: 'table-header',
    disabled: true,
    translate: true,
  },
  {
    value: 'contact_name',
    sort: ColumnSortType.NONE,
    name: 'contact',
    type: TableColumnTypes.TEXT,
    className: 'table-header',
    disabled: true,
    translate: true,
  },
  {
    value: 'contact_phone',
    sort: ColumnSortType.NONE,
    name: 'contact_phone',
    type: TableColumnTypes.TEXT,
    className: 'table-header',
    disabled: true,
    translate: true,
  },
  {
    value: 'url',
    sort: ColumnSortType.NONE,
    name: 'link',
    type: TableColumnTypes.LINK,
    className: 'table-header',
    disabled: true,
    translate: true,
  },
  {
    value: 'created_at',
    sort: ColumnSortType.NONE,
    name: 'created_at_olx',
    type: TableColumnTypes.DATE,
    className: 'table-header',
    disabled: true,
    translate: true,
  },
  {
    value: 'created_at_crm',
    sort: ColumnSortType.NONE,
    name: 'created_at_crm',
    type: TableColumnTypes.DATE,
    className: 'table-header',
    disabled: true,
    translate: true,
  },
  {
    value: 'action',
    sort: ColumnSortType.NONE,
    name: '',
    type: TableColumnTypes.ACTION,
    className: 'three-dot',
    actions:
      [
        { icon: 'restore', label: 'restore', value: 'RESTORE_ADVERT' },
      ],
    translate: true,
  },
];
